import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Get_All_SubAdmin, Get_All_Users, Get_Individual_user_wallet_details, Master_Dist_Signup, SubAdmin_Signup, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
const { Search } = Input;










const Subadmin = ({ Headername }) => {

    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "User Code",
            dataIndex: "userCode",
            width: 120,
            render: (code) => <Text copyable>{code}</Text>,
        },
        {
            title: "Name",
            dataIndex: "userName",
            width: 180,
        },
        {
            title: "Account Type",
            dataIndex: "acc_type",
            width: 120,
            render: (type) => (
                <Tag color={type === "Admin" ? "orange" : "purple"}>
                    {type}
                </Tag>
            ),
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
            width: 130,
            render: (mobile) => <Text copyable>{mobile}</Text>,
        },
        {
            title: "Created On",
            dataIndex: "createdAt",
            width: 170,
            render: (date) => dayjs(date).format("DD MMM YYYY"),
        },
        {
            title: "Action",
            width: 110,
            fixed: "right",
            render: (_, record) => (
                <Button
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelecteduser(record);
                        setUsersDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const [userStatustype, setUserstatus] = useState("ALL");
    const [searchuser, setSearchuser] = useState("");
    const [UsersDrawer, setUsersDrawer] = useState(false);
    const [selectedUser, setSelecteduser] = useState(null);
    // const [userprofileLoading, setUserprofileLoading] = useState(true); // self profile
    // const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 
    const [userfindloading, setUserloading] = useState(true);
    const [mappedUsers, setMappedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [walletData, setWalletData] = useState({});
    const [loadingWallet, setLoadingWallet] = useState({});
    const [createModal, setCreateModal] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);
    const [createProfile, setCreateProfile] = useState({
        subAdminname: "",
        subAdminemail: "",
        subAdminmobilenumber: "",
        subadminpassword: "",
        permissions: {
            home: true,
            balanceAndFunds: false,
            usersManagement: false,
            reports: false,
            banks: false,
            configuration: false,
            logs: false,
        }
    });
    const [updateWalletstatusloading, setWalletstatusloading] = useState(false);
    const [holdamount, setholdamount] = useState('');
    const [mpinModal, setMpinModal] = useState(false);
    const [mpin, setMpin] = useState("");
    const [holdLoading, setHoldLoading] = useState(false);

    const [editModalOpen, setEditModalOpen] = useState(false);

    const [editProfile, setEditProfile] = useState({
        _id: "",

        subAdminname: "",
        subAdminemail: "",
        subAdminmobilenumber: "",
        subadminpassword: "",
        permissions: {
            home: true,
            balanceAndFunds: false,
            usersManagement: false,
            reports: false,
            banks: false,
            configuration: false,
            logs: false,
        },
        isaccountblocked: false
    });

    const [editProfileLoading, setEditProfileLoading] = useState(false);

    const handleInput = (e) => {
        const { name, value } = e.target;

        setCreateProfile((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handlePermission = (service, checked) => {
        setCreateProfile((prev) => ({
            ...prev,
            permissions: {
                ...prev.permissions,
                [service]: checked,
            },
        }));
    };

    const handleSearch = () => {
        let filtered = [...mappedUsers];

        // Status Filter
        if (userStatustype !== "ALL") {
            filtered = filtered.filter((item) =>
                userStatustype === "Active"
                    ? !item.isaccountblocked
                    : item.isaccountblocked
            );
        }

        // Search Filter
        if (searchuser.trim()) {
            const keyword = searchuser.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.userName?.toLowerCase().includes(keyword) ||
                item.userCode?.toLowerCase().includes(keyword) ||
                String(item.mobile).includes(keyword)
            );
        }

        setFilteredUsers(filtered);
    };

    const handleReset = () => {
        setUserstatus("ALL");
        setSearchuser("");
        setFilteredUsers(mappedUsers);
    };

    const handleExpand = async (expanded, record) => {
        if (!expanded) return;
        // console.log(record);

        // Don't fetch again if already loaded
        if (walletData[record._id]) return;

        try {
            setLoadingWallet((prev) => ({
                ...prev,
                [record._id]: true,
            }));

            const data = await Get_Individual_user_wallet_details(record._id);

            if (data.success) {
                //console.log(data);

                setWalletData((prev) => ({
                    ...prev,
                    [record._id]: data.Userwallet,
                }));
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setLoadingWallet((prev) => ({
                ...prev,
                [record._id]: false,
            }));
        }
    };

    const update_user_wallet_status = async (record) => {
        const wallet = walletData[record._id];
        if (!wallet) {
            message.error('User wallet not found');
            return;
        }
        //console.log(wallet._id);

        const body = {
            walletid: wallet?._id,
            updatedWalletStatus: wallet?.isWalletBlocked === true ? false : true
        }

        try {
            setWalletstatusloading(true);
            const data = await Update_user_wallet_status(body);
            if (data.success) {
                //console.log(data);
                message.success(data.message);
                message.info('Please refresh the page for updated status');
                setWalletData({});
                setLoadingWallet({});
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setWalletstatusloading(false);
        }

    }

    const update_user_wallet_hold_balance = async () => {
        const wallet = Object.values(walletData)[0];

        //console.log(wallet._id);
        if (!wallet) {
            message.error('User wallet not found');
            return;
        }
        if (!holdamount) {
            message.error("Hold amount is required");
        }

        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }
        //console.log(wallet);

        const body = {
            walletid: wallet?._id,
            holdamount: holdamount,
            mpin
        }

        try {
            setHoldLoading(true);
            const data = await Update_user_wallet_hold_balance(body);
            if (data.success) {
                //console.log(data);
                message.success(data.message);
                message.info('Please refresh the page for updated status');
                setWalletData({});
                setLoadingWallet({});
                setMpinModal(false);
                setMpin('');
                setholdamount('');
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setHoldLoading(false);
        }

    }

    const expandedRowRender = (record) => {
        const wallet = walletData[record._id];

        if (loadingWallet[record._id]) {
            return <Spin />;
        }

        if (!wallet) {
            return <Empty description="No wallet found" />;
        }

        return (
            <Descriptions bordered size="small" column={3}>
                <Descriptions.Item label="Main Wallet">
                    ₹ {wallet.mainBalance}
                </Descriptions.Item>

                <Descriptions.Item label="Advance Credit">
                    ₹ {Math.abs(wallet.advanceCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Distributor Credit">
                    ₹ {Math.abs(wallet.distributorCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Master Dist Credit">
                    ₹ {Math.abs(wallet.masterDistributorCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Hold Amount">
                    ₹ {wallet.holdBalance}
                    <Button size="sm" variant="transparent" ml={'md'} onClick={() => setMpinModal(true)} loading={updateWalletstatusloading}>Update Hold</Button>
                </Descriptions.Item>

                <Descriptions.Item label="Wallet Status">
                    {wallet.walletStatus}
                    <Button size="sm" variant="transparent" ml={'md'} color={wallet?.isWalletBlocked ? 'green' : 'orange'} onClick={() => update_user_wallet_status(record)} loading={updateWalletstatusloading}>Update Status</Button>
                </Descriptions.Item>

                <Descriptions.Item label="Updated">
                    {dayjs(wallet.updatedAt).format("DD MMM YYYY hh:mm A")}
                </Descriptions.Item>
            </Descriptions>
        );
    };

    const requirements = [
        {
            re: /[A-Z]/,
            label: "Includes at least one uppercase letter",
        },
        {
            re: /[a-z]/,
            label: "Includes at least one lowercase letter",
        },
        {
            re: /\d/,
            label: "Includes at least one number",
        },
        {
            re: /[@$!%*?&]/,
            label: "Includes at least one special character (@$!%*?&)",
        },
    ];
    const getStrength = (password) => {
        let multiplier = password.length >= 8 ? 0 : 1;

        requirements.forEach((requirement) => {
            if (!requirement.re.test(password)) {
                multiplier += 1;
            }
        });

        return Math.max(
            100 - (100 / (requirements.length + 1)) * multiplier,
            0
        );
    };
    function PasswordRequirement({ meets, label }) {
        return (
            <Text
                component="div"
                c={meets ? "teal" : "red"}
                mt={5}
                size="sm"
            >
                <Center inline>
                    {meets ? (
                        <IconCheck size={14} stroke={1.5} />
                    ) : (
                        <IconX size={14} stroke={1.5} />
                    )}
                    <Box ml={7}>{label}</Box>
                </Center>
            </Text>
        );
    }
    const strength = getStrength(createProfile.subadminpassword);
    const color =
        strength === 100
            ? "teal"
            : strength > 60
                ? "lime"
                : strength > 30
                    ? "yellow"
                    : "red";
    const checks = requirements.map((requirement, index) => (
        <PasswordRequirement
            key={index}
            label={requirement.label}
            meets={requirement.re.test(createProfile.subadminpassword)}
        />
    ));
    const fetchSubAdmins = async () => {
        try {
            const data = await Get_All_SubAdmin();
            if (data.success) {
                //console.log(data);
                setMappedUsers(data?.subAdminLists);
                setFilteredUsers(data?.subAdminLists);
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setUserloading(false);
        }
    }

    const CreateSubAdmin_Profile = async () => {
        const { subAdminname, subAdminemail, subAdminmobilenumber, subadminpassword } = createProfile;
        if (!subAdminname || !subAdminemail || !subAdminmobilenumber || !subadminpassword) {
            message.error('All fields are required');
            return;
        }
        if (subAdminmobilenumber && (subAdminmobilenumber.length > 10 || subAdminmobilenumber.length < 10)) {
            message.error("Please enter valid 10 digit mobile number");
            return;
        }
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(subadminpassword)) {
            message.error('Incorrect Password');
            return
        }

        const body = {
            subAdminname,
            subAdminemail,
            subAdminmobilenumber,
            subadminpassword,
            home: createProfile.permissions.home,
            balanceAndFunds: createProfile.permissions.balanceAndFunds,
            usersManagement: createProfile.permissions.usersManagement,
            reports: createProfile.permissions.reports,
            banks: createProfile.permissions.banks,
            configuration: createProfile.permissions.configuration,
            logs: createProfile.permissions.logs,
        }
        try {
            setCreateLoading(true);
            const data = await SubAdmin_Signup(body);
            if (data.success) {
                //console.log(data);
                message.success(data?.message);
                setCreateProfile({
                    subAdminname: "",
                    subAdminemail: "",
                    subAdminmobilenumber: "",
                    subadminpassword: "",
                    permissions: {
                        home: true,
                        balanceAndFunds: false,
                        usersManagement: false,
                        reports: false,
                        banks: false,
                        configuration: false,
                        logs: false,
                    }
                })
                setCreateModal(false);
                fetchSubAdmins();
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setCreateLoading(false);
        }

    }

    // Edit handler 

    const OpenMasterDistributorEdit = () => {

        setEditProfile({
            _id: selectedUser._id,
            userName: selectedUser.subAdminname,
            email: selectedUser.email,
            mobile: selectedUser.mobile,
            dob: dayjs(selectedUser.dob),
            gender: selectedUser.gender,
            aadhar_no: selectedUser.aadhar_no,
            pan_no: selectedUser.pan_no,
            business_name: selectedUser.business_name,
            business_type: selectedUser.business_type,
            gst_no: selectedUser.gst_no,
            msme_no: selectedUser.msme_no,
            address: selectedUser.address,
            city: selectedUser.city,
            state: selectedUser.state,
            pincode: selectedUser.pincode,

            master_dist_id:
                selectedUser.master_dist_id?._id ||
                selectedUser.master_dist_id,

            services: {
                ...selectedUser.services
            }
        });

        setEditModalOpen(true);
    };

    const handleEditInput = (e) => {
        const { name, value } = e.target;

        setEditProfile((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handlePermissionChange = (service) => {
        setEditProfile((prev) => ({
            ...prev,
            permissions: {
                ...prev.permissions,
                [service]: !prev.services[service],
            },
        }));
    };

    const handleUpdateProfile = async () => {
        try {
            setEditProfileLoading(true);
            const body = {
                ...editProfile,
                dob: dayjs(editProfile.dob).format("YYYY-MM-DD"),
                topinRequest: editProfile?.services?.topinRequest,
                walletToWalletTransfer: editProfile?.services?.walletToWalletTransfer,
                fundTransferMapped: editProfile?.services?.fundTransferMapped,
            };

            const data = await Update_Master_dist_details(body);

            if (data.success) {

                message.success(data.message);

                setEditModalOpen(false);
                setUsersDrawer(false);
                setSelecteduser(false);
                fetchSubAdmins();
            }

        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setEditProfileLoading(false);
        }
    };

    useEffect(() => {
        const fetchSubAdmins = async () => {
            try {
                const data = await Get_All_SubAdmin();
                if (data.success) {
                    //console.log(data);
                    setMappedUsers(data?.subAdminLists);
                    setFilteredUsers(data?.subAdminLists);
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setUserloading(false);
            }
        }

        if (user) {
            fetchSubAdmins();
        }

    }, [user])

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Sub Admin</Title>
                <Text size="xs">Manage sub admin profile</Text>
            </Container>
            <Group justify="flex-end" mt="sm" mr={'md'}>
                <Button
                    variant="light"
                    onClick={() => setCreateModal(true)}

                >
                    Create Sub Admin Profile
                </Button>
            </Group>
            <Container size={'lg'} mt={'lg'}>
                <Card title="Listed sub admin" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        {/* <Col xs={24} md={4}>
                            <Select
                                placeholder="Retailers"
                                data={userTypeOptions}
                                value={whichuserLedger.userType}
                                onChange={handleUserTypeChange}
                                loading={userprofileLoading}
                            // style={{ width: "100%" }}
                            />
                        </Col> */}

                        <Col xs={24} md={4}>
                            <Select
                                value={userStatustype}
                                onChange={setUserstatus}
                                // style={{ width: "100%" }}
                                data={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "Active", value: "Active" },
                                    { label: "Blocked", value: "Blocked" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name / Mobile / User Code"
                                allowClear
                                value={searchuser}
                                onChange={(e) => setSearchuser(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                <Button type="secondary" variant="outline" onClick={fetchSubAdmins}>
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            expandable={{
                                expandedRowRender,
                                onExpand: handleExpand,
                            }}
                            dataSource={filteredUsers}
                            loading={userfindloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        />
                    </div>

                </Card>
            </Container>

            <Drawer
                title="User Details"
                width={650}
                opened={UsersDrawer}
                onClose={() => setUsersDrawer(false)}
            >
                {selectedUser && (
                    <>
                        <Descriptions
                            title="Basic Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="User Code">
                                {selectedUser.userCode}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Name">
                                {selectedUser.userName}
                            </Descriptions.Item>

                            <Descriptions.Item label="Account Type">
                                <Tag color="blue">
                                    {selectedUser.acc_type}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Mobile Number">
                                {selectedUser.mobile}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Enabled/Disabled Services"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Services">

                                <Space wrap>

                                    {Object.entries(selectedUser.permissions || {}).map(([key, value]) => (
                                        <Tag
                                            key={key}
                                            color={value ? "green" : "red"}
                                        >
                                            {key}
                                        </Tag>
                                    ))}

                                </Space>

                            </Descriptions.Item>

                        </Descriptions>

                        <Divider />

                        <Divider />

                        <Descriptions
                            title="Account Information"
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Password Changed">

                                {selectedUser.ispasswordchanged
                                    ? <Tag color="green">Yes</Tag>
                                    : <Tag color="red">No</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="MPIN Changed">

                                {selectedUser.ismpinchanged
                                    ? <Tag color="green">Yes</Tag>
                                    : <Tag color="red">No</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="Account Status">

                                {selectedUser.isaccountblocked
                                    ? <Tag color="red">Blocked</Tag>
                                    : <Tag color="green">Active</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="Created On">

                                {dayjs(selectedUser.createdAt).format("DD MMM YYYY hh:mm A")}

                            </Descriptions.Item>

                            <Descriptions.Item label="Updated On">

                                {dayjs(selectedUser.updatedAt).format("DD MMM YYYY hh:mm A")}

                            </Descriptions.Item>

                        </Descriptions>

                        <Group mt={'sm'} justify="flex-end">
                            <Button
                                onClick={OpenMasterDistributorEdit}
                            // onClick={() => {
                            //     setEditProfile({
                            //         _id: selectedUser._id,

                            //         userName: selectedUser.userName,
                            //         email: selectedUser.email,
                            //         mobile: selectedUser.mobile,

                            //         dob: dayjs(selectedUser.dob),
                            //         gender: selectedUser.gender,
                            //         aadhar_no: selectedUser.aadhar_no,
                            //         pan_no: selectedUser.pan_no,
                            //         business_name: selectedUser.business_name,
                            //         business_type: selectedUser.business_type,

                            //         gst_no: selectedUser.gst_no,
                            //         msme_no: selectedUser.msme_no,

                            //         address: selectedUser.address,
                            //         city: selectedUser.city,
                            //         state: selectedUser.state,
                            //         pincode: selectedUser.pincode,

                            //         isaccountblocked: selectedUser.isaccountblocked,

                            //         services: {
                            //             ...selectedUser.services,
                            //         },
                            //     });

                            //     setEditModalOpen(true);
                            // }}
                            >
                                Edit Profile
                            </Button>
                        </Group>
                    </>
                )}
            </Drawer>

            <Modal
                opened={createModal}
                onClose={() => setCreateModal(false)}
                title="Create Sub Admin"
                size="xl"
                centered
            >
                <SimpleGrid cols={2} spacing="md">

                    <TextInput
                        label="Full Name"
                        name="subAdminname"
                        value={createProfile.subAdminname}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Email"
                        name="subAdminemail"
                        value={createProfile.subAdminemail}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Mobile"
                        name="subAdminmobilenumber"
                        value={createProfile.subAdminmobilenumber}
                        onChange={handleInput}
                        maxLength={10}
                        required
                    />
                </SimpleGrid>

                <Divider my="lg">Security </Divider>

                <SimpleGrid cols={2}>

                    <PasswordInput
                        label="Password"
                        name="subadminpassword"
                        value={createProfile.subadminpassword}
                        onChange={handleInput}
                        required
                    />

                </SimpleGrid>
                {
                    createProfile.subadminpassword !== '' && (
                        <>
                            <Progress
                                value={strength}
                                color={color}
                                size="sm"
                                mt="xs"
                                radius="xl"
                            />

                            <Text size="xs" mt={5} fw={600}>
                                Password Strength:{" "}
                                {strength === 100
                                    ? "Strong"
                                    : strength > 60
                                        ? "Good"
                                        : strength > 30
                                            ? "Weak"
                                            : "Very Weak"}
                            </Text>

                            <PasswordRequirement
                                label="Has at least 8 characters"
                                meets={createProfile.subadminpassword.length >= 8}
                            />

                            {checks}
                        </>
                    )
                }

                <Divider my="lg">Service Permissions </Divider>

                <Stack gap="xs">

                    <Switch
                        label="Home"
                        checked={createProfile.permissions.home}
                        onChange={(e) =>
                            handlePermission("home", e.currentTarget.checked)
                        }
                    />

                    <Switch
                        label="Balance & Funds"
                        checked={createProfile.permissions.balanceAndFunds}
                        onChange={(e) =>
                            handlePermission("balanceAndFunds", e.currentTarget.checked)
                        }
                    />

                    <Switch
                        label="Users Managements"
                        checked={createProfile.permissions.usersManagement}
                        onChange={(e) =>
                            handlePermission("usersManagement", e.currentTarget.checked)
                        }
                    />
                    <Switch
                        label="Reports"
                        checked={createProfile.permissions.reports}
                        onChange={(e) =>
                            handlePermission("reports", e.currentTarget.checked)
                        }
                    />
                    <Switch
                        label="Banks"
                        checked={createProfile.permissions.banks}
                        onChange={(e) =>
                            handlePermission("banks", e.currentTarget.checked)
                        }
                    />
                    <Switch
                        label="Config & Updates"
                        checked={createProfile.permissions.configuration}
                        onChange={(e) =>
                            handlePermission("configuration", e.currentTarget.checked)
                        }
                    />

                    <Switch
                        label="Logs"
                        checked={createProfile.permissions.logs}
                        onChange={(e) =>
                            handlePermission("logs", e.currentTarget.checked)
                        }
                    />

                </Stack>

                <Group justify="flex-end" mt="xl">

                    <Button
                        variant="default"
                        onClick={() => setCreateModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        loading={createLoading}
                        onClick={CreateSubAdmin_Profile}
                    >
                        Create Sub Admin
                    </Button>

                </Group>
            </Modal>

            {/* <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Hold"
                centered
                radius="md"
                size="md"
            >
                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={8}>

                            <NumberInput
                                label="Hold Amount"
                                placeholder="Enter hold amount"
                                value={holdamount}
                                onChange={(value) => setholdamount(value)}
                                min={0}
                                hideControls
                                withAsterisk
                            />


                        </Stack>

                    </Paper>

                    <Divider />

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        fullWidth
                        size="md"
                        loading={holdLoading}
                        // color="green"
                        onClick={update_user_wallet_hold_balance}
                    >
                        Confirm Hold ₹ {Number(holdamount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal> */}

            <Modal
                opened={editModalOpen}
                onClose={() => setEditModalOpen(false)}
                size="xl"
                centered
                title="Edit Sub Admin"
            >
                {/* <Stack gap={8}> */}
                <SimpleGrid cols={2} spacing="md">

                    <TextInput
                        label="Full Name"
                        name="subAdminname"
                        value={editProfile.subAdminname}
                        onChange={handleEditInput}
                        required
                    />

                    <TextInput
                        label="Email"
                        name="subAdminemail"
                        value={editProfile.subAdminemail}
                        onChange={handleEditInput}
                        required
                    />

                    <TextInput
                        label="Mobile"
                        name="subAdminmobilenumber"
                        value={editProfile.subAdminmobilenumber}
                        onChange={handleEditInput}
                        maxLength={10}
                        required
                    />
                </SimpleGrid>

                {/* </Stack> */}
                <Divider my="lg">Service Permissions </Divider>

                <Stack gap="xs">

                    <Switch
                        label="Home"
                        checked={createProfile.permissions.home}
                        onChange={() => handlePermissionChange("home")}
                    />

                    <Switch
                        label="Balance & Funds"
                        checked={createProfile.permissions.balanceAndFunds}
                        onChange={() => handlePermissionChange("balanceAndFunds")}
                    />

                    <Switch
                        label="Users Managements"
                        checked={createProfile.permissions.usersManagement}
                        onChange={() => handlePermissionChange("usersManagement")}
                    />
                    <Switch
                        label="Reports"
                        checked={createProfile.permissions.reports}
                        onChange={() => handlePermissionChange("reports")}
                    />
                    <Switch
                        label="Banks"
                        checked={createProfile.permissions.banks}
                        onChange={() => handlePermissionChange("banks")}
                    />
                    <Switch
                        label="Config & Updates"
                        checked={createProfile.permissions.configuration}
                        onChange={() => handlePermissionChange("configuration")}

                    />

                    <Switch
                        label="Logs"
                        checked={createProfile.permissions.logs}
                        onChange={() => handlePermissionChange("logs")}
                    />

                </Stack>
                <Divider>Account Status</Divider>

                <Switch
                    label="Block Account"
                    checked={editProfile.isaccountblocked}
                    onChange={(event) =>
                        setEditProfile({
                            ...editProfile,
                            isaccountblocked: event.currentTarget.checked
                        })
                    }
                />

                <Group mt="xl" justify="flex-end">

                    <Button
                        variant="default"
                        onClick={() => setEditModalOpen(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleUpdateProfile}
                        loading={editProfileLoading}
                    >
                        Update Profile
                    </Button>

                </Group>

            </Modal>
        </>
    )
}

export default Subadmin;